export function handleXhrError(
  _uri: string,
  _xhr: XMLHttpRequest,
  callback: () => void
) {
  callback();
}

export function handleJQueryXhrError(
  _uri: string,
  _xhr: unknown,
  callback: () => void
) {
  callback();
}
